/* eslint max-len: 0 */
import React, { FC } from 'react';
import { SvgComponentProps } from './types';
import { Svg } from './Svg';

const Facebook: FC<SvgComponentProps> = (props) => {
	return (
		<Svg {...props}>
			<path
				d='M16 0.882143V15.1143C16 15.6036 15.6036 15.9964 15.1179 15.9964H11.0393V9.80357H13.1179L13.4286 7.38929H11.0357V5.84643C11.0357 5.14643 11.2286 4.67143 12.2321 4.67143H13.5107V2.51071C13.2893 2.48214 12.5321 2.41429 11.6464 2.41429C9.80357 2.41429 8.53929 3.53929 8.53929 5.60714V7.38929H6.45357V9.80357H8.53929V16H0.882143C0.396429 16 0 15.6036 0 15.1179V0.882143C0 0.396429 0.396429 0 0.882143 0H15.1143C15.6036 0 16 0.396429 16 0.882143Z'
				fill='#3B5998'
			/>
		</Svg>
	);
};

export { Facebook };
